<div class="component-main">
    <div class="content">
        <h1>{{ title | myLbTranslate }}</h1>
    </div>
    <app-display-code [data]="data" [errorMessage]="errorMessage"></app-display-code>
</div>
